import { render, staticRenderFns } from "./DriverConfigBonus.vue?vue&type=template&id=323955c9&scoped=true"
import script from "./DriverConfigBonus.vue?vue&type=script&lang=js"
export * from "./DriverConfigBonus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323955c9",
  null
  
)

export default component.exports